export const pt = {
  error: {
    general: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
  },
}
